module.exports = __webpack_public_path__ + "components/flag/static/square/mr-063a2050bd5facb185f989f34e181ee4.svg";